    import mitt from 'mitt';

    type Events = {
      'show-toast': { message: string; severity?: 'success' | 'info' | 'warn' | 'error'; summary?: string };
    };
    const eventBus = mitt<Events>();

    export default eventBus;
